import { render } from "./BiochemistryReport.vue?vue&type=template&id=7b7a7768"
import script from "./BiochemistryReport.vue?vue&type=script&lang=js"
export * from "./BiochemistryReport.vue?vue&type=script&lang=js"

import "./BiochemistryReport.vue?vue&type=style&index=0&id=7b7a7768&lang=scss"
import "./BiochemistryReport.vue?vue&type=style&index=1&id=7b7a7768&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__